module.exports = __webpack_public_path__ + "images/psp/PSPHero/dirt-bike-hero.webp";